import { Block } from "@/components/Block";
import { Header, HeaderActionBack, HeaderActionCustomerService } from "@/components/Header";
import { Icon } from "@/components/Icon";
import { Input } from "@/components/Input";
import { Layout } from "@/components/Layout";
import { Level } from "@/components/Level";
import { PaymentSelector, PaymentSelectorSellerProps } from "@/components/PaymentSelector";
import { TradeBoard } from "@/components/TradeBoard";
import { OrderType, Payments } from "@/constants";
import { amountFormat } from "@/utils/tool";
import { Avatar, Button, Selector } from "antd-mobile";
import styles from "./index.module.scss";
import { useSetup } from "./logic";
import * as Sentry from '@sentry/react';
import { FormTabs } from "./formTabs";
const separableOptions = [{
  label: "可拆分",
  value: OrderType.SEPARABLY
}, {
  label: "不可拆分",
  value: OrderType.INSEPARABLY
}];
export const PageSell = () => {
  const logic = useSetup();
  const RenderRange = () => {
    if (!(logic.state.payments as {
      [key: number]: number;
    })[0]) {
      return <></>;
    }
    if ((logic.state.payments as {
      [key: number]: number;
    })[0] === 1) {
      return logic.amountList.bankCard.map((val, i) => {
        return <a className={i === logic.state.rangeIndex ? styles.txtAction : ""} key={i} title={`${val.range_start}V币~${val.range_end}V币`} onClick={() => logic.changeAmount(i, val)}>{val.range_start}V币~{val.range_end}V币</a>;
      });
    } else {
      return logic.amountList.wechatAlipay.map((val, i) => {
        return <a className={i === logic.state.rangeIndex ? styles.txtAction : ""} key={i} title={`${val.range_start}V币~${val.range_end}V币`} onClick={() => logic.changeAmount(i, val)}>{val.range_start}V币~{val.range_end}V币</a>;
      });
    }
  };
  console.log('logic==', logic);
  return <Layout scrollable header={<Header title={logic.isMerchant ? "商家挂单" : "出售V币"} leftActions={<HeaderActionBack />} rightActions={<HeaderActionCustomerService />} />} data-sentry-element="Layout" data-sentry-component="PageSell" data-sentry-source-file="index.tsx">
      <div className={styles.main} key={logic.isPMerchant ? 'isPMerchant' : ''}>
        <TradeBoard contentClassName={styles.boardContent} backgroundClassName={styles.boardBackground} background={<>
              <div className={styles.content}>
          
                  <div className={styles.headerAvatar}>
                      <Avatar className={styles.avatar} src={logic.getSourcePath(logic.user.avatar)} />
                  </div>


                <div>
                  <div className={styles.username}>{logic.user.nickname}</div>
                  <div className={styles.levelWrapper}>
                    <div className={styles.levelLabel}>信用等级</div>
                    <Level level={logic.user.creditLevel} />
                  </div>
                </div>
              </div>
            </>} data-sentry-element="TradeBoard" data-sentry-source-file="index.tsx">
          <div className={styles.validAmount}>可出售总额</div>
          <div className={styles.amount}>
            <span>{amountFormat(logic.balance)}</span>
            <Icon name={"vcoin"} className={styles.amountIcon} data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
          </div>
        </TradeBoard>

        {logic.isMerchant ? <div className={styles.tabsHeader}>
            <FormTabs active={logic.isPMerchant ? "SuperMerchants" : "Merchants"} />
          </div> : null}

        {
      //非超级商家
      !logic.isPMerchant ? <Block title="是否可拆分">
            <Selector className={styles.selector} defaultValue={[logic.state.isSplit]} options={separableOptions} onChange={v => {
          logic.dispatch({
            type: "update-isSplit",
            isSplit: v[0]
          });
        }} />
          </Block> : null}
        

        <Block title="出售数量" data-sentry-element="Block" data-sentry-source-file="index.tsx">
            <Input className={styles.input} placeholder={logic.isPMerchant ? `` : `最低出售数量为10V币`} theme="plain" onChange={e => {
          Sentry.captureMessage(`${JSON.stringify(logic.user.userId)} sell input  ${e.target.value}`, "info");
          logic.dispatch({
            type: "update-amount",
            amount: e.target.value
          });
        }} data-sentry-element="Input" data-sentry-source-file="index.tsx" /> 
        </Block>

        {
      //超级商家
      logic.isPMerchant ? <div className={styles.professionWrap}>
                <p>
                  <span className={styles.subsidyRate}>补贴比例：<span>{logic.state.rangeData.subsidy_ratio || 0}%</span></span>
                  <span className={styles.subsidyAmount}>
                    补贴金额：<span>{logic.state.amount && (parseFloat(logic.state.amount) * (parseFloat(logic.state.rangeData.subsidy_ratio || '0') / 100)).toFixed(2) || "0.00"} V币</span>
                  </span>
                </p>
                <div className={styles.professionItem}>
                  {logic.state?.payments ? RenderRange() : ''}
                </div>
            </div> : null}


        {logic.state.isSplit === OrderType.SEPARABLY && !logic.isPMerchant && <Block title="最低购买">
            <Input className={styles.input} placeholder={`请填写买家最低可购买数量`} theme="plain" onChange={e => {
          logic.dispatch({
            type: "update-minBuyEach",
            minBuyEach: e.target.value
          });
        }} />
          </Block>}

        {/* 超级商家单选  切换收付方式 调接口获取补贴汇率 */}
        <Block title="请选择收款方式" data-sentry-element="Block" data-sentry-source-file="index.tsx">
          <PaymentSelector validPayments={logic.isPMerchant ? logic.paymentType : 0} onChange={((ids => {
          console.log(ids);
          logic.dispatch({
            type: "update-payments",
            paymentType: (Object.keys(ids).filter(v => ids[(Number(v) as Payments)] !== null).map(v => Number(v)) as Payments[]),
            payments: ids
          });
          // 超级商家
          if (logic.isPMerchant && logic.amountList.bankCard.length) {
            let pay_type = (ids as {
              [key: string | number]: string | number;
            })[0];
            logic.changeAmount(0, {
              range_start: pay_type ? pay_type === 1 ? logic.amountList.bankCard[0].range_start : logic.amountList.wechatAlipay[0].range_start : "",
              range_end: pay_type ? pay_type === 1 ? logic.amountList.bankCard[0].range_end : logic.amountList.wechatAlipay[0].range_end : "",
              subsidy_ratio: pay_type ? pay_type === 1 ? logic.amountList.bankCard[0].subsidy_ratio : logic.amountList.wechatAlipay[0].subsidy_ratio : ""
            });
          }
        }) as PaymentSelectorSellerProps["onChange"])} data-sentry-element="PaymentSelector" data-sentry-source-file="index.tsx" />
        </Block>

        <Button className={styles.publish} onClick={() => {
        logic.submit();
      }} data-sentry-element="Button" data-sentry-source-file="index.tsx">
          发布挂单
        </Button>

        {
      //超级商家
      logic.isPMerchant ? <div className={styles.tips}>
                <h4>重要提醒：</h4>
                <p>1.超级商家挂单买家由系统分配，分配购买用户时会自动开始交易，到账时须即时确认放币（由超级商家造成的交易失败，将会受到相应处罚）；</p>
                <p>2.当超级商家挂单时，系统会监控您的账号活跃度，如检测到您的账号未在活跃状态，系统会停止分配买家；</p>
                <p>3.对于多次违规超级商家，平台将会对其做出<span className={styles.txtDanger}>扣除保证金，永久封停账号</span>等严肃处理。</p>
            </div> : null}
        
      </div>
    </Layout>;
};